"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetCarouselCases = exports.GetRenovationDetails = exports.HasOpenMissingPerson = exports.GetMissingPersonImage = exports.GetMissingPeople = exports.FormSGCloseMissingPerson = exports.FormSGCreateMissingPerson = exports.GetCarParkDetails = exports.GetPurviewLocation = exports.ConvertLatLngToXY = exports.ReverseGeocodeXY = exports.ReverseGeocode = exports.ExtractCaseInfo = exports.PredictCategory = exports.UploadAttachments = exports.SubmitSurvey = exports.SubmitCase = exports.FetchOssgCasesBulk = exports.GetCases = exports.GetCase = exports.FetchCasesFromOssg = exports.Happenings = exports.MissingPerson = exports.CarPark = exports.Myinfo = exports.OneMap = exports.Cases = void 0;
const getCaseDomain = __importStar(require("./case/get-case/api-domain"));
const getCaseTransformer = __importStar(require("./case/get-case/transformer"));
const getCasesTransformer = __importStar(require("./case/get-cases/transformer"));
const getCasesDomain = __importStar(require("./case/get-cases/api-domain"));
const submitCaseDomain = __importStar(require("./case/submit-case/api-domain"));
const submitCaseTransformer = __importStar(require("./case/submit-case/transformer"));
const submitSurveyDomain = __importStar(require("./case/submit-survey/api-domain"));
const submitSurveyTransformer = __importStar(require("./case/submit-survey/transformer"));
const uploadAttachmentsDomain = __importStar(require("./case/upload-attachments/api-domain"));
const uploadAttachmentsTransformer = __importStar(require("./case/upload-attachments/transformer"));
const predictCategoryDomain = __importStar(require("./case/predict-category/api-domain"));
const predictCategoryTransformer = __importStar(require("./case/predict-category/transformer"));
const extractCaseInfoDomain = __importStar(require("./case/extract-case-info/api-domain"));
const extractCaseInfoTransformer = __importStar(require("./case/extract-case-info/transformer"));
const purviewLocationDomain = __importStar(require("./case/get-purview-location/api-domain"));
const purviewLocationTransformer = __importStar(require("./case/get-purview-location/transformer"));
const getCarParkDetailsDomain = __importStar(require("./car-park/get-car-park-details/api-domain"));
const getCarParkDetailsTransformer = __importStar(require("./car-park/get-car-park-details/transformer"));
const createMissingPersonDomain = __importStar(require("./missing-person/create-missing-person/api-domain"));
const createMissingPersonTransformer = __importStar(require("./missing-person/create-missing-person/transformer"));
const closeMissingPersonDomain = __importStar(require("./missing-person/close-missing-person/api-domain"));
const closeMissingPersonTransformer = __importStar(require("./missing-person/close-missing-person/transformer"));
const getMissingPeopleDomain = __importStar(require("./missing-person/get-missing-people/api-domain"));
const getMissingPeopleTransformer = __importStar(require("./missing-person/get-missing-people/transformer"));
const hasOpenMissingPersonDomain = __importStar(require("./missing-person/has-open-missing-person/api-domain"));
const hasOpenMissingPersonTransformer = __importStar(require("./missing-person/has-open-missing-person/transformer"));
const getRenovationDetailsDomain = __importStar(require("./happenings/get-renovation/api-domain"));
const getRenovationDetailsTransformer = __importStar(require("./happenings/get-renovation/transformer"));
const fetchOssgCasesBulkDomain = __importStar(require("./case/bulk-sync-cases/api-domain"));
const fetchOssgCasesBulkTransformer = __importStar(require("./case/bulk-sync-cases/transformer"));
const getReverseGeoCodeDomain = __importStar(require("./oneMap/get-reverse-geo-code/api-domain"));
const getReverseGeoCodeTransformer = __importStar(require("./oneMap/get-reverse-geo-code/transformer"));
const getCarouselCasesDomain = __importStar(require("./case/get-carousel-cases/api-domain"));
const getCarouselCasesTransformer = __importStar(require("./case/get-carousel-cases/transformer"));
__exportStar(require("./case/common"), exports);
__exportStar(require("./car-park/common"), exports);
__exportStar(require("./common"), exports);
var Cases;
(function (Cases) {
    Cases.baseRoute = "/api/v1/cases";
})(Cases || (exports.Cases = Cases = {}));
var OneMap;
(function (OneMap) {
    OneMap.baseRoute = "/api/v1/one-map";
})(OneMap || (exports.OneMap = OneMap = {}));
var Myinfo;
(function (Myinfo) {
    Myinfo.baseRoute = "/api/v1/myinfo";
})(Myinfo || (exports.Myinfo = Myinfo = {}));
var CarPark;
(function (CarPark) {
    CarPark.baseRoute = "/api/v1/car-park";
})(CarPark || (exports.CarPark = CarPark = {}));
var MissingPerson;
(function (MissingPerson) {
    MissingPerson.baseRoute = "/api/v1/missing-person";
})(MissingPerson || (exports.MissingPerson = MissingPerson = {}));
var Happenings;
(function (Happenings) {
    Happenings.baseRoute = "api/v1/happenings";
})(Happenings || (exports.Happenings = Happenings = {}));
var FetchCasesFromOssg;
(function (FetchCasesFromOssg) {
    FetchCasesFromOssg.method = "GET";
    FetchCasesFromOssg.internalRoute = `${Cases.baseRoute}/ossg`;
    FetchCasesFromOssg.route = `/oneservice${FetchCasesFromOssg.internalRoute}`;
})(FetchCasesFromOssg || (exports.FetchCasesFromOssg = FetchCasesFromOssg = {}));
var GetCase;
(function (GetCase) {
    GetCase.method = "GET";
    /**
     * append oneServiceCaseId to endpoint
     */
    GetCase.internalRoute = (oneServiceCaseId) => `${Cases.baseRoute}/${oneServiceCaseId}`;
    GetCase.route = (oneServiceCaseId) => `/oneservice${GetCase.internalRoute(oneServiceCaseId)}`;
    GetCase.Domain = getCaseDomain;
    GetCase.Transformers = getCaseTransformer;
})(GetCase || (exports.GetCase = GetCase = {}));
var GetCases;
(function (GetCases) {
    GetCases.method = "GET";
    GetCases.internalRoute = Cases.baseRoute;
    GetCases.route = `/oneservice${GetCases.internalRoute}`;
    GetCases.Domain = getCasesDomain;
    GetCases.Transformers = getCasesTransformer;
})(GetCases || (exports.GetCases = GetCases = {}));
var FetchOssgCasesBulk;
(function (FetchOssgCasesBulk) {
    FetchOssgCasesBulk.method = "GET";
    FetchOssgCasesBulk.internalRoute = Cases.baseRoute;
    FetchOssgCasesBulk.route = `/oneservice${FetchOssgCasesBulk.internalRoute}`;
    FetchOssgCasesBulk.Domain = fetchOssgCasesBulkDomain;
    FetchOssgCasesBulk.Transformers = fetchOssgCasesBulkTransformer;
})(FetchOssgCasesBulk || (exports.FetchOssgCasesBulk = FetchOssgCasesBulk = {}));
var SubmitCase;
(function (SubmitCase) {
    SubmitCase.method = "POST";
    SubmitCase.internalRoute = Cases.baseRoute;
    SubmitCase.route = `/oneservice${SubmitCase.internalRoute}`;
    SubmitCase.Domain = submitCaseDomain;
    SubmitCase.Transformers = submitCaseTransformer;
})(SubmitCase || (exports.SubmitCase = SubmitCase = {}));
var SubmitSurvey;
(function (SubmitSurvey) {
    SubmitSurvey.method = "PUT";
    SubmitSurvey.internalRoute = `${Cases.baseRoute}/surveys`;
    SubmitSurvey.route = `/oneservice${SubmitSurvey.internalRoute}`;
    SubmitSurvey.Domain = submitSurveyDomain;
    SubmitSurvey.Transformers = submitSurveyTransformer;
})(SubmitSurvey || (exports.SubmitSurvey = SubmitSurvey = {}));
var UploadAttachments;
(function (UploadAttachments) {
    UploadAttachments.method = "POST";
    UploadAttachments.internalRoute = `${Cases.baseRoute}/attachments/upload`;
    UploadAttachments.route = `/oneservice${UploadAttachments.internalRoute}`;
    UploadAttachments.Domain = uploadAttachmentsDomain;
    UploadAttachments.Transformers = uploadAttachmentsTransformer;
})(UploadAttachments || (exports.UploadAttachments = UploadAttachments = {}));
var PredictCategory;
(function (PredictCategory) {
    PredictCategory.method = "POST";
    PredictCategory.internalRoute = `${Cases.baseRoute}/predict`;
    PredictCategory.route = `/oneservice${PredictCategory.internalRoute}`;
    PredictCategory.Domain = predictCategoryDomain;
    PredictCategory.Transformers = predictCategoryTransformer;
})(PredictCategory || (exports.PredictCategory = PredictCategory = {}));
var ExtractCaseInfo;
(function (ExtractCaseInfo) {
    ExtractCaseInfo.method = "POST";
    ExtractCaseInfo.internalRoute = `${Cases.baseRoute}/extract`;
    ExtractCaseInfo.route = `/oneservice${ExtractCaseInfo.internalRoute}`;
    ExtractCaseInfo.Domain = extractCaseInfoDomain;
    ExtractCaseInfo.Transformers = extractCaseInfoTransformer;
})(ExtractCaseInfo || (exports.ExtractCaseInfo = ExtractCaseInfo = {}));
var ReverseGeocode;
(function (ReverseGeocode) {
    ReverseGeocode.method = "GET";
    ReverseGeocode.internalRoute = `${OneMap.baseRoute}/reverse-geo-code`;
    ReverseGeocode.route = `/oneservice${ReverseGeocode.internalRoute}`;
    ReverseGeocode.Domain = getReverseGeoCodeDomain;
    ReverseGeocode.Transformers = getReverseGeoCodeTransformer;
})(ReverseGeocode || (exports.ReverseGeocode = ReverseGeocode = {}));
var ReverseGeocodeXY;
(function (ReverseGeocodeXY) {
    ReverseGeocodeXY.method = "GET";
    ReverseGeocodeXY.internalRoute = `${OneMap.baseRoute}/reverse-geo-code-xy`;
    ReverseGeocodeXY.route = `/oneservice${ReverseGeocodeXY.internalRoute}`;
})(ReverseGeocodeXY || (exports.ReverseGeocodeXY = ReverseGeocodeXY = {}));
var ConvertLatLngToXY;
(function (ConvertLatLngToXY) {
    ConvertLatLngToXY.method = "GET";
    ConvertLatLngToXY.internalRoute = `${OneMap.baseRoute}/convert-latlng-to-xy`;
    ConvertLatLngToXY.route = `/oneservice${ConvertLatLngToXY.internalRoute}`;
})(ConvertLatLngToXY || (exports.ConvertLatLngToXY = ConvertLatLngToXY = {}));
var GetPurviewLocation;
(function (GetPurviewLocation) {
    GetPurviewLocation.method = "GET";
    GetPurviewLocation.internalRoute = `${Cases.baseRoute}/illegal-parking/purview-location`;
    GetPurviewLocation.route = `/oneservice${GetPurviewLocation.internalRoute}`;
    GetPurviewLocation.Domain = purviewLocationDomain;
    GetPurviewLocation.Transformers = purviewLocationTransformer;
})(GetPurviewLocation || (exports.GetPurviewLocation = GetPurviewLocation = {}));
var GetCarParkDetails;
(function (GetCarParkDetails) {
    GetCarParkDetails.method = "GET";
    GetCarParkDetails.internalRoute = CarPark.baseRoute;
    GetCarParkDetails.route = `/oneservice${GetCarParkDetails.internalRoute}`;
    GetCarParkDetails.Domain = getCarParkDetailsDomain;
    GetCarParkDetails.Transformers = getCarParkDetailsTransformer;
})(GetCarParkDetails || (exports.GetCarParkDetails = GetCarParkDetails = {}));
var FormSGCreateMissingPerson;
(function (FormSGCreateMissingPerson) {
    FormSGCreateMissingPerson.method = "POST";
    FormSGCreateMissingPerson.internalRoute = `${MissingPerson.baseRoute}/create`;
    FormSGCreateMissingPerson.route = `/oneservice${FormSGCreateMissingPerson.internalRoute}`;
    FormSGCreateMissingPerson.Domain = createMissingPersonDomain;
    FormSGCreateMissingPerson.Transformers = createMissingPersonTransformer;
})(FormSGCreateMissingPerson || (exports.FormSGCreateMissingPerson = FormSGCreateMissingPerson = {}));
var FormSGCloseMissingPerson;
(function (FormSGCloseMissingPerson) {
    FormSGCloseMissingPerson.method = "POST";
    FormSGCloseMissingPerson.internalRoute = `${MissingPerson.baseRoute}/close`;
    FormSGCloseMissingPerson.route = `/oneservice${FormSGCloseMissingPerson.internalRoute}`;
    FormSGCloseMissingPerson.Domain = closeMissingPersonDomain;
    FormSGCloseMissingPerson.Transformers = closeMissingPersonTransformer;
})(FormSGCloseMissingPerson || (exports.FormSGCloseMissingPerson = FormSGCloseMissingPerson = {}));
var GetMissingPeople;
(function (GetMissingPeople) {
    GetMissingPeople.method = "GET";
    GetMissingPeople.internalRoute = `${MissingPerson.baseRoute}/missing-people`;
    GetMissingPeople.route = `/oneservice${GetMissingPeople.internalRoute}`;
    GetMissingPeople.Domain = getMissingPeopleDomain;
    GetMissingPeople.Transformers = getMissingPeopleTransformer;
})(GetMissingPeople || (exports.GetMissingPeople = GetMissingPeople = {}));
var GetMissingPersonImage;
(function (GetMissingPersonImage) {
    GetMissingPersonImage.method = "GET";
    GetMissingPersonImage.internalRoute = (missingPersonCaseId) => `${MissingPerson.baseRoute}/missing-people/image/${missingPersonCaseId}`;
    GetMissingPersonImage.route = (missingPersonCaseId) => `/oneservice${GetMissingPersonImage.internalRoute(missingPersonCaseId)}`;
})(GetMissingPersonImage || (exports.GetMissingPersonImage = GetMissingPersonImage = {}));
var HasOpenMissingPerson;
(function (HasOpenMissingPerson) {
    HasOpenMissingPerson.method = "GET";
    HasOpenMissingPerson.internalRoute = `${MissingPerson.baseRoute}/has-open-missing-person`;
    HasOpenMissingPerson.route = `/oneservice${HasOpenMissingPerson.internalRoute}`;
    HasOpenMissingPerson.Domain = hasOpenMissingPersonDomain;
    HasOpenMissingPerson.Transformers = hasOpenMissingPersonTransformer;
})(HasOpenMissingPerson || (exports.HasOpenMissingPerson = HasOpenMissingPerson = {}));
var GetRenovationDetails;
(function (GetRenovationDetails) {
    GetRenovationDetails.method = "GET";
    GetRenovationDetails.internalRoute = (id) => `${Happenings.baseRoute}/notices/renovations/${id}`;
    GetRenovationDetails.route = (id) => `/oneservice${GetRenovationDetails.internalRoute(id)}`;
    GetRenovationDetails.Domain = getRenovationDetailsDomain;
    GetRenovationDetails.Transformer = getRenovationDetailsTransformer;
})(GetRenovationDetails || (exports.GetRenovationDetails = GetRenovationDetails = {}));
var GetCarouselCases;
(function (GetCarouselCases) {
    GetCarouselCases.method = "POST";
    GetCarouselCases.internalRoute = `${Cases.baseRoute}/carousel-cases`;
    GetCarouselCases.route = `/oneservice${GetCarouselCases.internalRoute}`;
    GetCarouselCases.Domain = getCarouselCasesDomain;
    GetCarouselCases.Transformers = getCarouselCasesTransformer;
})(GetCarouselCases || (exports.GetCarouselCases = GetCarouselCases = {}));
//# sourceMappingURL=index.js.map